import { reactive, ref } from "vue";

export function useKyuukeiInputModal() {
  const kyuukeiInputModalRef = ref()

  const kyuukeiInputModalParts = reactive({
    title: '休憩時間の入力',
    button: ''
  })

  const openKyuukeiInputModal = () => {
    kyuukeiInputModalRef.value.open()
  }

  const closeKyuukeiInputModal = () => {
    kyuukeiInputModalRef.value.close()
  }

  return {
    kyuukeiInputModalRef,
    kyuukeiInputModalParts,
    openKyuukeiInputModal,
    closeKyuukeiInputModal,
  }
}
